import { render, staticRenderFns } from "./ImageTextNavPreview.vue?vue&type=template&id=39baa24a&scoped=true"
import script from "./ImageTextNavPreview.vue?vue&type=script&lang=js"
export * from "./ImageTextNavPreview.vue?vue&type=script&lang=js"
import style0 from "./ImageTextNavPreview.vue?vue&type=style&index=0&id=39baa24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39baa24a",
  null
  
)

export default component.exports